/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Log_In_Legacy_TitleInputs */

const en_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please Create a Seekr ID`)
};

const ar_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى إنشاء معرف سيكر`)
};

const de_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte erstellen Sie eine Seekr ID`)
};

const es_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, crea una ID de Seekr`)
};

const fr_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez créer un Seekr ID`)
};

const it_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ti preghiamo di creare un ID Seekr`)
};

const ja_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seekr IDを作成してください`)
};

const ko_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seekr ID를 만드세요`)
};

const pt_br_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um Seekr ID`)
};

const ru_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте Seekr ID`)
};

const th_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดสร้าง Seekr ID`)
};

const tr_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen Bir Seekr ID Oluştur`)
};

const zh_cn_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先创建 Seekr ID`)
};

const zh_tw_dialog_log_in_legacy_title = /** @type {(inputs: Dialog_Log_In_Legacy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請先建立 Seekr ID`)
};

/**
* | output |
* | --- |
* | "Please Create a Seekr ID" |
*
* @param {Dialog_Log_In_Legacy_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_log_in_legacy_title = /** @type {((inputs?: Dialog_Log_In_Legacy_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Log_In_Legacy_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_log_in_legacy_title(inputs)
	if (locale === "ar") return ar_dialog_log_in_legacy_title(inputs)
	if (locale === "de") return de_dialog_log_in_legacy_title(inputs)
	if (locale === "es") return es_dialog_log_in_legacy_title(inputs)
	if (locale === "fr") return fr_dialog_log_in_legacy_title(inputs)
	if (locale === "it") return it_dialog_log_in_legacy_title(inputs)
	if (locale === "ja") return ja_dialog_log_in_legacy_title(inputs)
	if (locale === "ko") return ko_dialog_log_in_legacy_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_log_in_legacy_title(inputs)
	if (locale === "ru") return ru_dialog_log_in_legacy_title(inputs)
	if (locale === "th") return th_dialog_log_in_legacy_title(inputs)
	if (locale === "tr") return tr_dialog_log_in_legacy_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_log_in_legacy_title(inputs)
	return zh_tw_dialog_log_in_legacy_title(inputs)
});